import loadable from '@loadable/component';

export const ModalLoadable = loadable(() => import('./Modal').then((module) => ({ default: module.Modal })));
